import './index.css'

const RepositoryItem = props => {
  const {details} = props
  const {name, issuesCount, forksCount, starsCount, avatarUrl} = details

  return (
    <li className="repo-card">
      <img src={avatarUrl} alt={name} className="repo-img" />
      <h3 className="repo-name">{name}</h3>
      <div className="stats">
        <p className="para">
          <img
            src="https://assets.ccbp.in/frontend/react-js/stars-count-img.png "
            alt="stars"
            className="img"
          />
          {starsCount} stars
        </p>
        <p className="para">
          <img
            src="https://assets.ccbp.in/frontend/react-js/forks-count-img.png "
            alt="forks"
            className="img"
          />
          {forksCount} forks
        </p>
        <p className="para">
          <img
            src="https://assets.ccbp.in/frontend/react-js/issues-count-img.png "
            alt="open issues"
            className="img"
          />
          {issuesCount} issues
        </p>
      </div>
    </li>
  )
}

export default RepositoryItem
